/**
 * Shared Loki API URL construction
 *
 * Used by FaroMetricsService (analytics dashboard) and SystemLogsApiService (system logs page)
 * to build the correct environment-specific Loki endpoint.
 *
 * Pattern: https://{prefix}.logs.docbits.com/loki/api/v1
 * Production: https://logs.docbits.com/loki/api/v1 (no prefix)
 * Localhost/local: falls back to dev endpoint
 */

/**
 * Build the Loki API base URL for the current environment.
 * Reads from import.meta.env by default; parameters can be overridden for testing.
 */
export function getLokiApiUrl(
  environment?: string,
  branch?: string,
): string {
  const appEnv = (environment ?? process.env.APP_VUE_STAGE ?? 'dev').toString().trim().toLowerCase();
  const appBranch = (branch ?? process.env.APP_VUE_BRANCH ?? 'dev').toString().trim().toLowerCase();

  if (appEnv === 'local' || (typeof window !== 'undefined' && window.location.hostname === 'localhost')) {
    return 'https://dev.logs.docbits.com/loki/api/v1';
  }

  if (appEnv === 'prod' || appBranch === 'prod' || appBranch === 'pre-prod') {
    return 'https://logs.docbits.com/loki/api/v1';
  }

  const prefix = appBranch || appEnv || 'dev';
  return `https://${prefix}.logs.docbits.com/loki/api/v1`;
}
